export default __webpack_public_path__ + "static/media/leader_notes.7db9eafb.pdf";